import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TokenStorageService } from '../_services/token-storage.service';
import { AuthService } from '../_services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private tokens: TokenStorageService,
    private router: Router
  ) {}

canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
  const token = this.tokens.getAccessToken();
  const exp = this.tokens.getAccessExpiresAt();
  const expired = exp ? new Date(exp).getTime() <= Date.now() : false;

  if (!token || expired) {
    this.auth.forceLogout(false);
    return this.router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
  }
  return true;
}
}
